<template>
  <div class="app-content ap trash">
    <div class="row mb-4">
      <div class="col">
        <div class="d-flex h-100 w-100 align-items-center">
          <h1 class="ap__main-title">{{ type }} Trash</h1>
        </div>
      </div>
      <div class="col-auto">
        <template v-if="type == 'subnote'">
          <button @click="backToCheck()" class="btn btn-primary">Back to Check</button>
        </template>
        <template v-else>
          <router-link to="/dashboard" class="btn btn-primary">Back to Dashboard</router-link>
        </template>
      </div>
    </div>
    <div class="content-block">
      <div class="content-block__body">
        <template v-if="type == 'folder'">
          <table class="table trash__table" v-if="trashFolders.length">
            <thead>
              <tr>
                <th>Folder name</th>
                <th>Date</th>
                <th>User</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="folder in trashFolders" :key="folder.folder_id">
                <td class="trash__item-name">{{ folder.folder_title }}</td>
                <td>{{ folder.deleted_at | moment('YYYY-MM-DD') }}</td>
                <td><template v-if="folder.deleted_from">{{ folder.deleted_from.username }}</template></td>
                <td>
                  <button class="trash__action mr-3" @click="trashRestore(folder)" title="Restore"><svg viewBox="0 0 512 512"><path d="M142.716,293.147l-94-107.602l94-107.602c7.596-8.705,6.71-21.924-1.995-29.527c-8.705-7.596-21.917-6.703-29.527,1.995 L5.169,171.782c-6.892,7.882-6.892,19.65,0,27.532l106.026,121.372c4.143,4.729,9.94,7.157,15.771,7.157 c4.883,0,9.786-1.702,13.755-5.169C149.427,315.071,150.319,301.852,142.716,293.147z"/><path d="M359.93,164.619H20.926C9.368,164.619,0,173.986,0,185.545c0,11.558,9.368,20.926,20.926,20.926H359.93 c60.776,0,110.218,49.441,110.218,110.211S420.706,426.893,359.93,426.893H48.828c-11.558,0-20.926,9.368-20.926,20.926 c0,11.558,9.368,20.926,20.926,20.926H359.93c83.844,0,152.07-68.219,152.07-152.063S443.781,164.619,359.93,164.619z"/></svg></button>
                  <button class="trash__action" @click="trashDelete(folder)" title="Delete permanently"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center" v-else>The trash is empty</div>
        </template>
        <template v-if="type == 'note'">
          <table class="table trash__table" v-if="trashNotes.length">
            <thead>
              <tr>
                <th>Note</th>
                <th>Subnote</th>
                <th>Date</th>
                <th>User</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="note in trashNotes" :key="note.obj_id">
                <td class="trash__item-name"><template v-if="note.obj == 'NOTE'">{{ note.obj_descr }}</template></td>
                <td class="trash__item-name"><template v-if="note.obj == 'SUBNOTE'">{{ note.obj_descr }}</template></td>
                <td>{{ note.deleted_at | moment('YYYY-MM-DD') }}</td>
                <td><template v-if="note.deleted_from">{{ note.deleted_from.username }}</template></td>
                <td class="text-right">
                  <template v-if="note.deleted_at">
                    <button class="trash__action mr-3" @click="trashRestore(note)" title="Restore"><svg viewBox="0 0 512 512"><path d="M142.716,293.147l-94-107.602l94-107.602c7.596-8.705,6.71-21.924-1.995-29.527c-8.705-7.596-21.917-6.703-29.527,1.995 L5.169,171.782c-6.892,7.882-6.892,19.65,0,27.532l106.026,121.372c4.143,4.729,9.94,7.157,15.771,7.157 c4.883,0,9.786-1.702,13.755-5.169C149.427,315.071,150.319,301.852,142.716,293.147z"/><path d="M359.93,164.619H20.926C9.368,164.619,0,173.986,0,185.545c0,11.558,9.368,20.926,20.926,20.926H359.93 c60.776,0,110.218,49.441,110.218,110.211S420.706,426.893,359.93,426.893H48.828c-11.558,0-20.926,9.368-20.926,20.926 c0,11.558,9.368,20.926,20.926,20.926H359.93c83.844,0,152.07-68.219,152.07-152.063S443.781,164.619,359.93,164.619z"/></svg></button>
                    <button class="trash__action" @click="trashDelete(note)" title="Delete permanently"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center" v-else>The trash is empty</div>
        </template>
        <template v-if="type == 'subnote'">
          <table class="table trash__table" v-if="trashSubnotes.length">
            <thead>
              <tr>
                <th>Subnote</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="subnote in trashSubnotes" :key="subnote.obj_id">
                <td class="trash__item-name">
                  <div class="mb-3">{{ subnote.text }}</div>
                  <ul class="trash__item-tt mb-3" v-if="subnote.taxonomies">
                    <li v-for="taxonomy in subnote.taxonomies" :key="taxonomy" class="trash__item-taxonomy">
                      {{ getTaxonomyLabel(taxonomy) }}
                    </li>
                    <li v-for="target in subnote.targets" :key="target"  class="trash__item-target">
                      {{ getTargetLabel(target) }}
                    </li>
                  </ul>
                  <p>Folder <strong>{{ subnote.folder.folder_title }}</strong> / Note <strong>{{ subnote.note.note_title }}</strong></p>
                </td>
                <td class="text-right">
                  <button class="trash__action mr-3" @click="trashRestore(subnote)" title="Restore"><svg viewBox="0 0 512 512"><path d="M142.716,293.147l-94-107.602l94-107.602c7.596-8.705,6.71-21.924-1.995-29.527c-8.705-7.596-21.917-6.703-29.527,1.995 L5.169,171.782c-6.892,7.882-6.892,19.65,0,27.532l106.026,121.372c4.143,4.729,9.94,7.157,15.771,7.157 c4.883,0,9.786-1.702,13.755-5.169C149.427,315.071,150.319,301.852,142.716,293.147z"/><path d="M359.93,164.619H20.926C9.368,164.619,0,173.986,0,185.545c0,11.558,9.368,20.926,20.926,20.926H359.93 c60.776,0,110.218,49.441,110.218,110.211S420.706,426.893,359.93,426.893H48.828c-11.558,0-20.926,9.368-20.926,20.926 c0,11.558,9.368,20.926,20.926,20.926H359.93c83.844,0,152.07-68.219,152.07-152.063S443.781,164.619,359.93,164.619z"/></svg></button>
                  <button class="trash__action" @click="trashDelete(subnote)" title="Delete permanently"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center" v-else>The trash is empty</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { taxTag } from '../mixins/taxTag.js';

export default {
  name: "Trash",
  props: ['folder', 'previousProps'],
  mixins: [taxTag],
  data() {
    return {
      type: null,
      id: null,
      trashFolders: [],
      trashNotes: [],
      trashSubnotes: []
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"])
  },
  methods: {
    setApiHeader() {
      ApiService.setHeader();
    },
    getTrashFolders() {
      ApiService.get("searchclass/garbage/")
      .then((response) => {
        this.trashFolders = response.data;
      });
    },
    getTrashNotes() {
      ApiService.get("searchclass/garbage/" + this.id + '/')
      .then((response) => {
        this.trashNotes = response.data;
      });
    },
    getTrashSubnotes() {
      ApiService.get("searchclass/garbage/" + this.id + '/subnotes/')
      .then((response) => {
        this.trashSubnotes = response.data;
      });
    },
    trashRestore(object) {
      if(this.type == 'folder') {
        ApiService.update("folders/" + object.folder_id + "/garbage/")
        .then(() => {
          this.getTrashFolders();
          Swal.fire(
            'Restored!',
            'Folder ' + object.folder_title + ' has been restored!',
            'success'
          );
        });
      }
      if(this.type == 'note') {
        let typeEndpoint = 'notes';
        let typeNotification = 'Note';
        if(object.obj == 'SUBNOTE') {
          typeEndpoint = 'subnotes';
          typeNotification = 'Subnote';
        }
        ApiService.update(typeEndpoint + "/" + object.obj_id + "/garbage/")
        .then(() => {
          this.getTrashNotes();
          Swal.fire(
            'Restored!',
            typeNotification + ' has been restored!',
            'success'
          );
        });
      }
      if(this.type == 'subnote') {
        ApiService.update("subnotes/" + object.subnote_id + "/garbage/")
        .then(() => {
          this.getTrashSubnotes();
          Swal.fire(
            'Restored!',
            'Subnote has been restored!',
            'success'
          );
        });
      }
    },
    trashDelete(object) {
      if(this.type == 'folder') {

        Swal.fire({
          title: 'Delete permanently',
          text: "Are you sure you want to delete the folder " + object.folder_title + "? You won't be able to revert this action",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!'
        }).then((response) => {

          if (response.value) {
            ApiService.delete("folders/" + object.folder_id + "/garbage/")
            .then(() => {
              this.getTrashFolders();
              Swal.fire(
                'Deleted!',
                'Folder ' + object.folder_title + ' has been deleted!',
                'success'
              );
            });
          }

        });
      }
      if(this.type == 'note') {

        let typeEndpoint = 'notes';
        let typeNotification = 'Note';
        if(object.obj == 'SUBNOTE') {
          typeEndpoint = 'subnotes';
          typeNotification = 'Subnote';
        }

        Swal.fire({
          title: 'Delete permanently',
          text: "Are you sure you want to delete this " + typeNotification + "? You won't be able to revert this action",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!'
        }).then((response) => {

          if (response.value) {
            ApiService.delete(typeEndpoint + "/" + object.obj_id + "/garbage/")
            .then(() => {
              this.getTrashNotes();
              Swal.fire(
                'Deleted!',
                typeNotification + ' has been deleted!',
                'success'
              );
            });
          }

        });
      }
      if(this.type == 'subnote') {
        Swal.fire({
          title: 'Delete permanently',
          text: "Are you sure you want to delete this subnote? You won't be able to revert this action",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!'
        }).then((response) => {

          if (response.value) {
            ApiService.delete("subnotes/" + object.subnote_id + "/garbage/")
            .then(() => {
              this.getTrashSubnotes();
              Swal.fire(
                'Deleted!',
                'Subnote has been deleted!',
                'success'
              );
            });
          }

        });
      }
    },
    backToCheck() {
      // Se per un refresh non abbiamo dati da passare, evitiamo di tornare alla schermata di check
      // in quanto sarebbe vuota. 
      if(this.previousProps != undefined) {
        this.$router.push({
          name: 'Check',
          params: {
            folder: this.previousProps.folder,
            returnTo: this.previousProps.returnTo,
            subnote: this.previousProps.subnote,
            article: this.previousProps.article
          }
        });
      } else {
        this.$router.push({
          name: 'Dashboard'
        });
      }
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    this.setApiHeader();

    this.type = this.$route.params.type;
    this.id = this.$route.params.id;

    if(this.type == 'folder' && !this.id) {
      this.getTrashFolders();
    }

    if(this.type == 'note' && this.id) {
      this.getTrashNotes();
    }

    if(this.type == 'subnote' && this.id) {
      this.getTrashSubnotes();
    }
  }
}
</script>

<style lang="scss">
 
 .trash {

  &__table.table {
    font-size: rem(14px);
    color: $color-abbey;
    font-weight: 400;
    margin-bottom: 0;

    tbody {
      font-family: $font-family-roboto;
    }
  }

  &__item-name {
    font-family: $font-family-montserrat;
    color: #000;
  }

  &__item-tt {
    font-family: $font-family-montserrat;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: inline-block;
      font-size: rem(12px);
      padding: rem(4px) rem(8px);
      border: 1px solid rgba(0, 0, 0, 0.2);
      color: $color-genoa;
      text-transform: uppercase;

      &:not(:first-child) {
        margin-left: rem(8px);
      }

      &.trash__item-target {
        color: $color-java;
      }
    }
  }

  &__action {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill:$color-java;
      }
    }
  }

 } 

</style>